import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { FormMaskedInput } from "../../../../../../common/components/masked_inputs/react_forms/form_masked_input";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useCallback, useEffect, useState } from "react";
import { ModalLoading } from "../../../../../../common/components/modal_loading";


import PrimaryButton from "../../../../../../common/components/primary_button";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";

import { ItemMedicaoTerceirizacaoForm, ItemMedicaoTerceirizacaoSchema } from "../../../schemas/Medicao/itens_medicao_terceirizacao";
import { DefaultFormCheckBox } from "../../../../../../common/components/default_form_checkbox";
import { DropDownProdutoServicoContrato } from "../../../../../../common/components/dropdown_produtoservico_contrato";
import { DropDownProdutoServico } from "../../../../../../common/components/dropdown_produtoservico";
import { DropDownSubconta } from "../../../../../../common/components/dropdown_subconta";
import { FormMoneyMaskedInput } from "../../../../../../common/components/masked_inputs/react_forms/form_money_masked_input";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { isNotNullOrUndefined } from "../../../../../../common/utils/utils";
import { DefaultFormNumericInput } from "../../../../../../common/components/default_form_numeric_input";


type Props = {
  open: boolean,
  saving: boolean,
  selectedItem: ItemMedicaoTerceirizacaoForm | null,
  IdMedicaoTerceirizacao: number;
  IdContrato: number;
  validFormulario: boolean;
  onSubmit: (form: ItemMedicaoTerceirizacaoForm) => void,
  onOpenChangeHistory: (id: number, tabelaTipo: LogTipoTabela) => void,
  onClose: () => void,
};

export const ItensModal = ({
  open,
  saving,
  IdMedicaoTerceirizacao,
  IdContrato,
  selectedItem,
  validFormulario,
  onOpenChangeHistory,
  onSubmit,
  onClose,
}: Props) => {
  const hookForm = useForm<ItemMedicaoTerceirizacaoForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(ItemMedicaoTerceirizacaoSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedItem) {
        hookForm.reset({
          Detalhamento: selectedItem.Detalhamento,
          IdItemMedicaoTerceirizacao: selectedItem.IdItemMedicaoTerceirizacao,
          IdMedicaoTerceirizacao: selectedItem.IdMedicaoTerceirizacao,
          IdProdutoServico: selectedItem.IdProdutoServico ?? 0,
          Quantidade: selectedItem.Quantidade ?? 0,
          ValorTotal: selectedItem.ValorTotal,
          ValorUnitario: selectedItem.ValorUnitario ?? 0,
          IdSubconta: selectedItem.IdSubconta,
        });
      }
      } else {
        hookForm.reset({
         Detalhamento: "",
        IdItemMedicaoTerceirizacao: 0,
        IdMedicaoTerceirizacao: IdMedicaoTerceirizacao,
        IdProdutoServico: 0,
        IdSubconta: 0,
        Quantidade: 0,
        ValorTotal: 0,
        ValorUnitario: 0,
        });
      }
  }, [hookForm, open, selectedItem, IdMedicaoTerceirizacao]);

  
  const handleChangeHistory = useCallback(() => {
    if (selectedItem) {
      onOpenChangeHistory(selectedItem.IdItemMedicaoTerceirizacao, LogTipoTabela.ITEM_MEDICAO_TERCEIRIZACAO);
    }
  }, [selectedItem, onOpenChangeHistory]);

  const handleSubmit = useCallback((form: ItemMedicaoTerceirizacaoForm) => {
    if (!saving){
      onSubmit(form);
      // hookForm.reset(); 
    } 
  }, [onSubmit, saving]);

  const handleClose = useCallback(() => {
    if (!saving){
      onClose();
      hookForm.reset(); 
    } 
  }, [hookForm, onClose, saving]);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="md"
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: hookForm.handleSubmit(handleSubmit),
        }
      }}
       sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "52rem",
          },
        },
      }}
      >
      <DialogTitle>
        Itens da Medição
      </DialogTitle>

      <DialogContent>
        <ModalLoading loading={saving}>
          <FormContainer title={selectedItem ? "Editar" : "Cadastrar"} arrangement="fullRow">
            <>
              <div className="flex-1">
              <div className="flex flex-row gap-x-8">
                  {hookForm.watch("CheckBoxServico") === true ? (
                    <DropDownProdutoServicoContrato
                      name='IdProdutoServico'
                      label="Serviço"
                      idContrato={IdContrato}
                      required={true}
                      reactHookForm={hookForm}
                    />

                  ) : (
                    <DropDownProdutoServico
                      name='IdProdutoServico'
                      label="Serviço"
                      required={true}
                      reactHookForm={hookForm}
                      tipo="S"
                    />
                  )}
                </div>
                <DefaultFormCheckBox name='CheckBoxServico' label='Mostrar serviços do contrato' reactHookForm={hookForm} />
                <div className="flex-1">
              </div>
            </div>
            <DropDownSubconta
              name="IdSubconta"
              label="Subconta"
              readOnly={validFormulario}
              reactHookForm={hookForm}
            />
            <div className="md:col-span-2">
              <DefaultFormNumericInput
                name="Quantidade"
                label="Quantidade"
                required={true}
                reactHookForm={hookForm}
              />
            </div>

            <FormMoneyMaskedInput
              name='ValorUnitario'
              label="Valor Unitário R$"
              required={true}
              reactHookForm={hookForm}
            />
              <DefaultFormInput
                name="Detalhamento"
                label="Detalhamento"
                rows={4}
                multiline={true}
                reactHookForm={hookForm}
              />
            </>
          </FormContainer>
        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-between flex p-4 gap-4">
          <div className="w-[220px]">
            {
              isNotNullOrUndefined(selectedItem) &&
              <PrimaryButton
                buttonColor="yellow"
                onClick={handleChangeHistory}>
                <span className="text-xs">
                  Historico de alterações
                </span>
              </PrimaryButton>
            }
          </div>
          <div className="flex flex-row gap-2 w-full justify-end">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              {saving ? (
                <PrimaryButton
                  buttonColor="primary-green">
                  Salvando...
                </PrimaryButton>
              ) : (
                <PrimaryButton
                  type="submit"
                  buttonColor="primary-green">
                  Salvar
                </PrimaryButton>
              )}
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}